/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Users module

define('modules/Newsletter/Newsletter.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
        'ManageUser': {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '#first-name',
                    "Type": 'Text'
                },
                {
                    "Name": 'Last Name',
                    "Field": '#last-name',
                    "Type": 'Text'
                }
            ],
            Validate: true
        },
        'ManageEmail': {
            Fields: [
                {
                    "Name": 'Email',
                    "Field": '#managePreferencesEmailField',
                    "Type": 'Text',
                    'Validators': [{ 'Type': 'Email' }]
                }
            ],
            Validate: true
        },
        'ManageEmailRail': {
            Fields: [
                {
                    "Name": 'Email',
                    "Field": '#newsletterTextboxDefault',
                    "Type": 'Text',
                    'Validators': [{ 'Type': 'Email' }]
                }
            ],
            Validate: true
        },
        'BenchmarkSignup': {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '#benchmark-first-name',
                    'Param': 'firstName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Last Name',
                    "Field": '#benchmark-last-name',
                    "Param": 'lastName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Email Address',
                    "Field": '#benchmark-email-address',
                    "Param": 'email',
                    "Type": 'Text',
                    "Validators": [{
                        'Type': 'Email'
                    }]
                },
                {
                    "Name": 'Company Name',
                    "Field": '#benchmark-company-name',
                    "Param": 'companyName',
                    "Type": 'Text'
                },
                {
                    "Name": 'Address',
                    "Field": '#benchmark-address',
                    "Param": 'address',
                    "Type": 'Text'
                },
                {
                    "Name": 'City',
                    "Field": '#benchmark-city',
                    "Param": 'city',
                    "Type": 'Text'
                },
                {
                    "Name": 'State',
                    "Field": '#benchmark-state',
                    "Param": 'state',
                    "Type": 'Text'
                },
                {
                    "Name": 'Zip Code',
                    "Field": '#benchmark-zip',
                    "Param": 'zip',
                    "Type": 'Text'
                },
                {
                    "Name": 'Country',
                    "Field": '#benchmark-country',
                    "Param": 'country',
                    "Type": 'Text'
                },
                {
                    "Name": 'Phone',
                    "Field": '#benchmark-phone',
                    "Param": 'phone',
                    "Type": 'Text',
                    "Validators": [
                        {
                            "Type": 'Phone'
                        }
                    ]
                },
                {
                    "Name": 'Job Title',
                    "Field": '#benchmark-job-title',
                    "Param": 'jobTitle',
                    "Type": 'Text'
                },
                {
                    "Name": 'Notes',
                    "Field": '#benchmark-notes',
                    "Param": 'notes',
                    "Type": 'Text',
                    "Optional": true
                }
            ],
            Validate: true
        }
    };

    return forms;
});
